module.exports = __webpack_public_path__ + "static/media/intro_icon_7.7efee3be.svg";